import { CRS, MAXIC_DISCOUNT_PROD_TYPE } from '../../config';
import {
	CRS_CHECK_CREDENTIALS,
	CRS_CHECK_CREDENTIALS_SUCCESS,
	CRS_CHECK_CREDENTIALS_FAIL,
	CRS_USAGE_UPDATE,
	CRS_USAGE_UPDATE_SUCCESS,
	CRS_USAGE_UPDATE_FAIL,
	CRS_SAVE_TAKEOVER_CREDENTIALS,
	CRS_CLEAR_CREDENTIALS,
	COUPON_CHANGE_MAGIX_DISCOUNT_PRODUCT_TYPE
} from './actions';
import { extractPropsforAxiosHttpError } from '../../errors/errorhelper';
import ERRORS from '../../errors/errorids';
import AppError from '../../errors/apperror';
import HttpError from '../../errors/httperror';
import _ from 'lodash';
import Logger from '../../logger/logger';
const log = Logger.get('crs');

const initialState = {
	areCredentialsValid: null,
	checkCredentialsErrorid: null,
	checkCredentialsErrorMessage: null,
	checkCredentialsInvalidReason: null,
	crsUsageUpdateSuccess: null,
	crsUsageUpdateErrorId: null,
	prodCatOfLastValidCombination: null,
	tierOfLastValidCombination: null,
	isFallbackProductReturnedLastValidCombination: null,
	takeoverMagixEmail: null,
	takeoverProductSerial: null,
	prodTypeOfLastValidCombination: null,
	crsResponseCache: null
};

function getCredentialsState(state, result, payload) {
	if (payload.magixDiscountProdType === MAXIC_DISCOUNT_PROD_TYPE.PERPETUAL) {

		return {
			...state,
			areCredentialsValid: result.valid,
			checkCredentialsErrorid: !result.valid && ERRORS.CRS_INVALID_CREDENTIALS,
			checkCredentialsErrorMessage: !result.valid && result.message,
			checkCredentialsInvalidReason: !result.valid && result.reason,

			// Never overwrite previous store values to null after failure case
			...(result.valid && 
				{ tierOfLastValidCombination: result.tier }),
			...(result.valid && 
					{ isFallbackProductReturnedLastValidCombination: result.fb }),
			...(result.valid &&
				{ prodCatOfLastValidCombination: result.prod_cat }),
			...(result.valid &&
				{ prodTypeOfLastValidCombination: payload.magixDiscountProdType }),
			...(result.valid &&
					{ crsResponseCache: result })
		};
	} else {
		const isUsedForSubscription = result.used_for_sub;

		return {
			...state,
			areCredentialsValid: result.valid && !isUsedForSubscription,
			checkCredentialsErrorid: (!result.valid || isUsedForSubscription) && (isUsedForSubscription
				?
				ERRORS.CRS_CREDENTIALS_ALREADY_USED
				:
				ERRORS.CRS_INVALID_CREDENTIALS),
			checkCredentialsErrorMessage: (!result.valid || isUsedForSubscription) &&
			result.message,
			checkCredentialsInvalidReason: (!result.valid || isUsedForSubscription) &&
			result.reason,

			// Never overwrite previous store values to null after invalid or failure case
			...(result.valid && !isUsedForSubscription && 
				{ tierOfLastValidCombination: result.tier }),
			...(result.valid && !isUsedForSubscription && 
				{ isFallbackProductReturnedLastValidCombination: result.fb }),
			...(result.valid && !isUsedForSubscription &&
				{ prodCatOfLastValidCombination: result.prod_cat }),
			...(result.valid && !isUsedForSubscription &&
				{ prodTypeOfLastValidCombination: payload.magixDiscountProdType }),
			...(result.valid &&
					{ crsResponseCache: result })						
		};
	}
}

export default (state = initialState, action) => {
	switch (action.type) {

		/* credentials check */
		case CRS_CHECK_CREDENTIALS:
			return {
				...state,
				areCredentialsValid: null,
				checkCredentialsErrorid: null,
				checkCredentialsErrorMessage: null,
				checkCredentialsInvalidReason: null
			};

		case CRS_CHECK_CREDENTIALS_SUCCESS: {
			return getCredentialsState(state, action.result, action.payload);
		}

		case CRS_CHECK_CREDENTIALS_FAIL: {

			let messageFromMw;
			let firstMessageId;
			if (action.error && action.error instanceof AppError) {
				// Extract message from MW response
				const firstMessage = action.error.getMesageFromHistoryAtIndex(0);

				if (firstMessage) {
					messageFromMw = _.get(firstMessage, 'responseText.message') || _.get(firstMessage, 'responseText');
					firstMessageId = firstMessage.errorId;
				}
			}

			return {
				...state,
				areCredentialsValid: false,
				checkCredentialsErrorid: firstMessageId || ERRORS.CRS_INFO_REQUEST_FAILED,
				checkCredentialsErrorMessage: messageFromMw,
				checkCredentialsInvalidReason: null,
			};
		}
		
		/* save takeover credentials */ 
		case CRS_SAVE_TAKEOVER_CREDENTIALS:
			return {
				...state,
				takeoverMagixEmail: action.payload.magixEmail,
				takeoverProductSerial: action.payload.productSerial
			};

		/* clear credentials */
		case CRS_CLEAR_CREDENTIALS:
			return {
				...initialState
			};

			/* change product type*/
		case COUPON_CHANGE_MAGIX_DISCOUNT_PRODUCT_TYPE: {
			if (state.prodTypeOfLastValidCombination &&
					state.prodTypeOfLastValidCombination !== action.payload.magixDiscountProdType) {

				const newState = getCredentialsState(state, state.crsResponseCache, action.payload);

				return {
					...newState,
					prodTypeOfLastValidCombination: action.payload.magixDiscountProdType
				};			
			} else {
				return state;
			}
		}

		default:
			return state;

	}
};

export const updateUsage = (magixEmail, productSerial, currentUserEmail, magixDiscountProdType) => {
	return (dispatch) => {
		return dispatch({
			types: [CRS_USAGE_UPDATE, CRS_USAGE_UPDATE_SUCCESS, CRS_USAGE_UPDATE_FAIL],
			promise: client => client.post(CRS.USAGE_URL, {
				email: magixEmail,
				serial: productSerial,
				used_by_email: currentUserEmail,
				used_for_order_type: magixDiscountProdType,
				action: 'save'
			}).catch((error) => {
				const httpErrorProps = extractPropsforAxiosHttpError(error);
				// don't show error msg to user here as user won't be redoing purchase
				log.send(new AppError({
					message: 'Crs.updateUsage() failed',
					errorId: ERRORS.UNKNOWN,
					originalError: new HttpError(httpErrorProps),
					errorDetails: {
						email: window.btoa(magixEmail),
						serial: window.btoa(productSerial),
						used_by_email: currentUserEmail,
					},					
					visualisers: { feature: 'CRS' }
				}));
			})
		});
	};
};

export const checkCrsCredentials = (magixEmail, productSerial, currentUserEmail, magixDiscountProdType) => {
	return (dispatch) => {
		return dispatch({
			types: [CRS_CHECK_CREDENTIALS, CRS_CHECK_CREDENTIALS_SUCCESS, CRS_CHECK_CREDENTIALS_FAIL],
			payload: {
				magixDiscountProdType
			},			
			promise: client => client.post(CRS.INFO_URL, {
				email: magixEmail,
				session_email: currentUserEmail,
				serial: productSerial,
				action: 'get',
				'usage': true
			})
				.then(response => {
					return {...response.data, magixEmail, productSerial};
				})
				.catch(async (error) => {
					const httpErrorProps = extractPropsforAxiosHttpError(error);
					const nError = new AppError({
						message: 'user.checkCrsCredentials() failed',
						errorId: ERRORS.UNKNOWN,
						originalError: new HttpError(httpErrorProps),
						visualisers: { feature: 'CRS' }
					});
	
					throw nError;
				})
		});
	};
};

export const saveTakeOverCredentials = (magixEmail, productSerial) => {
	return dispatch => {
		dispatch({
			type: CRS_SAVE_TAKEOVER_CREDENTIALS,
			payload: {
				magixEmail,
				productSerial
			}
		});
	};
};

export const clearCrsCredentials = () => {
	return dispatch => {
		dispatch({
			type: CRS_CLEAR_CREDENTIALS
		});
	};
};

export const changeMagixDiscountProdType = (
	magixDiscountProdType,
	prodCatOfLastValidCombination,
	tierOfLastValidCombination,
	areCredentialsValid) => {
	return dispatch => {
		dispatch({
			type: COUPON_CHANGE_MAGIX_DISCOUNT_PRODUCT_TYPE,
			payload: { magixDiscountProdType, prodCatOfLastValidCombination, tierOfLastValidCombination, areCredentialsValid }
		});
	};
};


// WEBPACK FOOTER //
// ./src/redux/modules/crs.js